import Logger from "../../../utils/Logger";
import WebService from "../../../services/WebService"
import MscoreStepPersist from "./persistence/MscoreStepPersist"

export const BEST_MSCORE_SERVER_COUNT = 5;

/**
 * Represent a mScore step
 */
export default class MscoreBestServer {

    /**
     * @param {ConfigStepMscore} configuration server
     * @param {UrlBuilder} url builder
     */
    constructor(configuration, urlBuilder) {
        this.configuration = configuration;
        this.urlBuilder = urlBuilder;
        this.webService = new WebService();
        this.persistence = new MscoreStepPersist();
    }

    /**
     * Select random mScore servers
     * @returns {Array} The list of servers
     */
    selectBestMScoreServerRandomly() {
        let selectedServers = [];
        let configurationServers = Array.from(this.configuration.servers);

        // Select previous server URL
        let previousBestMScoreServerUrl = this.persistence.getBestMscoreServer(this.configuration);
        if (previousBestMScoreServerUrl) {
            selectedServers.push(previousBestMScoreServerUrl);
            let i = configurationServers.indexOf(previousBestMScoreServerUrl);
            if (i > -1) {
                configurationServers.splice(i, 1);
            }
        }

        Logger.log("Server list count for step : " + configurationServers.length);
        while (selectedServers.length < BEST_MSCORE_SERVER_COUNT && configurationServers.length > 0) {
            let serverIndex = Math.floor((Math.random() * configurationServers.length));
            selectedServers.push(configurationServers[serverIndex]);
            configurationServers.splice(serverIndex, 1);
        }

        return selectedServers;
    }

    /**
     * Return a promise which select best mScore server
     * @returns {Promise}
     */
    bestServer() {
        const webService = this.webService;
        const persist = this.persistence;
        const stepConfig = this.configuration;

        // For backward compliancy and avoid useless calls, return directly the server without doing anything if there is only one server set
        if (stepConfig.servers.length == 1) {
            return new Promise((resolve) => {
                resolve(stepConfig.servers[0]);
            });
        }

        const selectedServers = this.selectBestMScoreServerRandomly();

        Logger.log("Server random list : ");
        Logger.log(selectedServers);

        // Build promises array
        let checkUrlPromises = [];
        const urlBuilder = this.urlBuilder;
        let errorCount = 0;

        // Create promises for each URL
        selectedServers.forEach(function (mScoreSelectedServer) {
            const checkUrl = urlBuilder.buildCheckServerUrl(mScoreSelectedServer);
            checkUrlPromises.push(new Promise((resolve, reject) => {
                webService.get(checkUrl).then((content) => {
                    Logger.log(content);
                    resolve(mScoreSelectedServer);
                }).catch((error) => {
                    errorCount++;
                    if (errorCount == selectedServers.length) {
                        reject(error);
                    }
                });
            }));
        });

        // Return the promise.race
        return new Promise((resolve, reject) => {
            Promise.race(checkUrlPromises).then((mScoreServerUrl) => {
                Logger.log("Best mScore server picked URL : " + mScoreServerUrl);
                persist.saveBestMscoreServer(mScoreServerUrl, stepConfig);
                resolve(mScoreServerUrl);
            }).catch((error) => {
                Logger.log("Best mScore server pick failed");
                Logger.log(error);
                reject(error);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/MscoreBestServer.js